{
  "eyebrow": "Billing & payment",
  "title": "Almost there.",
  "sub": "Continue to our secure checkout to start your 30-day trial. You won't be charged today.",
  "summary": {
    "plan": "Plan",
    "cycle": "Billing cycle",
    "users": "Users",
    "vtt": "Vehicle Track & Trace",
    "vehicles": "Vehicles",
    "total": "Estimated total / month",
    "vttOn": "Included"
  },
  "secureNote": "Secure checkout by Stripe · 30-day free trial · Cancel anytime",
  "continue": "Continue to Stripe",
  "submitting": "Opening Stripe…",
  "canceled": {
    "title": "Payment cancelled",
    "sub": "No charge was made. Try again or contact us if you need help.",
    "retry": "Try again"
  },
  "promo": {
    "toggle": "Have a promo code?",
    "placeholder": "Promo code",
    "apply": "Apply",
    "chip": "{{percent}}% off",
    "remove": "Remove promo code",
    "errorGeneric": "Couldn't check the code. Please try again."
  },
  "errors": {
    "generic": "Could not start checkout. Please try again."
  },
  "totalUnavailable": "Price catalog unavailable. Retry to load the latest pricing."
}
